import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { translations, LANGS } from "@/i18n/translations";

const LanguageContext = createContext(null);

const getNested = (obj, path) =>
  path.split(".").reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : undefined), obj);

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState(() => {
    const saved = typeof window !== "undefined" ? localStorage.getItem("lp_lang") : null;
    return saved && LANGS.some((l) => l.code === saved) ? saved : "fr";
  });

  useEffect(() => {
    localStorage.setItem("lp_lang", lang);
    document.documentElement.lang = lang;
  }, [lang]);

  const t = useCallback(
    (path) => {
      const value = getNested(translations[lang], path);
      return value !== undefined ? value : getNested(translations.fr, path) ?? path;
    },
    [lang],
  );

  return (
    <LanguageContext.Provider value={{ lang, setLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLang = () => {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLang must be used within LanguageProvider");
  return ctx;
};
